import api from './api';

// Iniciar sesión
const login = async (email, password) => {
  try {
    console.log('Intentando iniciar sesión con:', { email });
    const response = await api.post('/api/auth/login', { email, password });
    console.log('Respuesta de login:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error en el servicio de login:', error);
    throw error;
  }
};

// Registrar un nuevo usuario (solo admin)
const register = async (userData) => {
  try {
    const response = await api.post('/api/auth/register', userData);
    return response.data;
  } catch (error) {
    console.error('Error en el servicio de registro:', error);
    throw error;
  }
};

// Obtener perfil de usuario
const getProfile = async () => {
  try {
    const response = await api.get('/api/auth/profile');
    return response.data;
  } catch (error) {
    console.error('Error al obtener perfil:', error);
    throw error;
  }
};

// Actualizar perfil de usuario
const updateProfile = async (userData) => {
  try {
    const response = await api.put('/api/auth/profile', userData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar perfil:', error);
    throw error;
  }
};

const authService = {
  login,
  register,
  getProfile,
  updateProfile
};

export default authService; 